import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionIntro() {
  return <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-185" data-mp="30n63oxoxunr">
      <div className="absolute inset-0 bg-stadium-glow opacity-50 pointer-events-none" data-id="element-186" data-mp="31y9vor4z2ev"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-187" data-mp="3lc9uh9usqbg9">
        <div className="max-w-4xl mx-auto text-center" data-id="element-188" data-mp="3qdz7gv1kwz6z">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-189" data-mp="hxnlcsyp3x5c">
            <h2 className="font-anton text-4xl md:text-6xl text-gold-500 uppercase tracking-wide mb-4" data-id="element-190" data-mp="81asfxaz5nbn">
              THE SOLUTION YOU'VE BEEN WAITING FOR
            </h2>
            <h3 className="font-oswald text-2xl md:text-3xl text-white uppercase tracking-widest mb-12" data-id="element-191" data-mp="2sonoxw20cwqr">
              A COMPLETE 6-VOLUME COACHING SYSTEM
            </h3>
            <p className="text-xl text-gray-300 font-medium mb-12" data-id="element-192" data-mp="2x95vkzwcv077">
              Designed specifically for football coaches.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="mb-16 relative" data-id="element-193" data-mp="2taozdbeh3a4k">
            <div className="absolute -inset-4 bg-gold-500/10 blur-2xl rounded-full" data-id="element-194" data-mp="3c7q5x0nodiam"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qJHa7epYciq8VTrPkY2Abk/ChatGPT_Image_11_jun_2026,_14_59_45.webp" alt="Football Ready System 365 — 6 powerful volumes, one complete system" loading="lazy" decoding="async" className="relative w-full max-w-3xl mx-auto h-auto rounded-xl shadow-2xl border border-navy-700/50" data-id="element-195" data-mp="3pybrix4ik6c7" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="prose prose-lg prose-invert mx-auto text-gray-300" data-id="element-196" data-mp="5wtbgwn1lgeq">
            <p className="text-xl md:text-2xl font-medium text-white mb-6" data-id="element-197" data-mp="km7jo1evtrsj">
              FOOTBALL READY: SYSTEM 365 is much more than a coaching manual.
            </p>
            <p className="mb-8 leading-relaxed" data-id="element-198" data-mp="tj9k00f50low">
              It is a complete coaching operating system that gives you
              structured player development, ready-to-use sessions, tactical
              progression, season planning tools, evaluation systems, and coach
              management resources.
            </p>
            <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 font-oswald text-xl text-gold-400 uppercase tracking-wider" data-id="element-199" data-mp="35alwaj1sgdw8">
              <span data-id="element-200" data-mp="2xs5uft02f8qd">✓ Everything organized.</span>
              <span data-id="element-201" data-mp="2xsxf48s4jm1v">✓ Everything structured.</span>
              <span data-id="element-202" data-mp="2szm7i5fhn18w">✓ Everything ready to use.</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}